export default class TutorialIndexSummary
{

    constructor(linkToSection,indexName)
    {
        this.LinkToSection = linkToSection;
        this.IndexName = indexName;
    }

    /** @type {string} */
    LinkToSection;

    /** @type {string} */
    IndexName;
    
}